import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { hasAutoReplenishmentSubscriptionsSelector } from 'viewModel/selectors/user/hasAutoReplenishmentSubscriptionsSelector';
import { getFeatureFlags } from 'components/RichProfile/MyAccount/AutoReplenishment/utils/featureFlags';

/**
 * Custom hook for Auto Replenishment Page Content component.
 * Determines whether to render the empty hub or regular auto replenishment content
 * based on feature flags and user subscription status.
 *
 * @returns {Object} Hook state
 * @returns {boolean} returns.shouldRenderEmptyHub - True if empty hub should be displayed
 */
const useAutoReplenishmentPageContent = () => {
    const hasAutoReplenishmentSubscriptions = useSelector(hasAutoReplenishmentSubscriptionsSelector);

    const featureFlags = useMemo(getFeatureFlags, []);

    const shouldRenderEmptyHub = featureFlags.isAutoReplenishEmptyHubEnabled && !hasAutoReplenishmentSubscriptions;

    return {
        shouldRenderEmptyHub
    };
};

export default useAutoReplenishmentPageContent;
